module.exports = __webpack_public_path__ + "img/MI_T.a2b02308.png";